export function goToUrl(url: string) {
  window.location.assign(url);
}
